import { NgModule } from "@angular/core";
import { DashboardHomeComponent } from "./home/dashboard-home.component";
import { GridsModule } from "./ag-grid/ag-grid.module";
import { CarouselModule } from 'ngx-owl-carousel-o';
import { HttpClient } from "@angular/common/http";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { HttpLoaderFactory } from "src/app/app.module";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SettingsPanelComponent } from "./settings-panel/settings-panel.component";
import { NavbarComponent } from "./navbar/navbar.component";
import { SpinnerComponent } from "./spinner/spinner.component";
import { FooterComponent } from "./footer/footer.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CardsModule } from "./card/cards.module";
import { ToastrModule } from "ngx-toastr";
import { ChartsModule } from "ng2-charts";
import { DistDashboardComponent } from "./home/distributor/dist-dashboard.component";
import { AdminDashboardComponent } from "./home/admin/admin-dashboard.component";
import { AgGridModule } from "ag-grid-angular";
import { ChildChartComponent } from "./home/distributor/charts/charts.component";
import { ChildKPIsComponent } from "./home/distributor/kpis/kpis.component";
import { AlertChartComponent } from "./home/distributor/kpis/kpiCharts/alert-chart.component";
import { ActiveTanksChartComponent } from "./home/distributor/kpis/kpiCharts/active-tanks-chart.component";
import { UnitsChartComponent } from "./home/distributor/kpis/kpiCharts/units-chart.component";
import { AdminChartsComponent } from "./home/admin/charts/admin-charts.component";
import { AdminKPIsComponent } from "./home/admin/kpis/kpis-admin.component";
import { CustomerDashboardComponent } from "./home/customer/customer-dashboard.component";
import { CustomerProfileComponent } from "./home/customer/profile/profile.component";
import { CustomerModule } from "./home/customer/customer.module";
import { NewAlertsComponent } from "./home/new/newAlerts.component";
import { NewPreferencesComponent } from "./home/new/newPreferences.component";
import { NewMeteringComponent } from "./home/new/newMetering.component";
import { CustomerAlertsComponent } from "./home/customer/alerts/alerts.component";
import { NewDashboardComponent } from "./home/new/newDashboard.component";
import { DistributorDashboardComponent } from "./home/distributor/distributor-dashboard.component";
import { ManufacturingDashboardComponent } from "./home/manufacturing/manufacturing-dashboard.component";
import { HelpPageComponent } from "./help/help-page.component";



@NgModule({
  declarations: [
    DashboardHomeComponent,
    AdminDashboardComponent,
    DistDashboardComponent,
    DistributorDashboardComponent,
    CustomerDashboardComponent,
    CustomerProfileComponent,
    CustomerAlertsComponent,
    SpinnerComponent,
    FooterComponent,
    SidebarComponent,
    SettingsPanelComponent,
    NavbarComponent,
    ChildChartComponent,
    ChildKPIsComponent,
    AlertChartComponent,
    ActiveTanksChartComponent,
    UnitsChartComponent,
    AdminChartsComponent,
    AdminKPIsComponent,
    NewAlertsComponent,
    NewPreferencesComponent,
    NewMeteringComponent,
    NewDashboardComponent,
    ManufacturingDashboardComponent,
    HelpPageComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    NgbModule,
    CarouselModule,
    BrowserAnimationsModule,
    CustomerModule,
    CardsModule,
    GridsModule,
    ChartsModule,
    AgGridModule,
    ToastrModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  exports: [
    SidebarComponent,
    SettingsPanelComponent,
    NavbarComponent,
    SpinnerComponent,
    FooterComponent
  ]
})
  export class DashboardModule { }
